import React, { useMemo, useRef } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import useClickOutside from '../../hooks/useClickOutside';
import useEscapeKey from '../../hooks/useEscapeKey';
import RippleButton from '../RippleButton';

function formatMonth(monthValue) {
  const [y, m] = monthValue.split('-').map(Number);
  const date = new Date(y, m - 1, 1);
  return date.toLocaleString('default', { month: 'long', year: 'numeric' });
}

export default function MonthDropdown({ months, value, onChange }) {
  const [open, setOpen] = React.useState(false);
  const rootRef = useRef(null);

  useClickOutside(rootRef, () => setOpen(false));
  useEscapeKey(open, () => setOpen(false));

  const label = useMemo(() => formatMonth(value), [value]);

  return (
    <div className="dropdown" ref={rootRef}>
      <RippleButton className="dropdown__trigger" type="button" onClick={() => setOpen((v) => !v)}>
        <span className="dropdown__trigger-label">{label}</span>
        <span className={`dropdown__caret ${open ? 'dropdown__caret--open' : ''}`}>▾</span>
      </RippleButton>

      <AnimatePresence>
        {open && (
          <motion.div
            className="dropdown__panel dropdown__panel--month"
            initial={{ opacity: 0, y: 8, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 6, scale: 0.99 }}
            transition={{ duration: 0.16 }}
            role="menu"
            aria-label="Month filter"
          >
            <div className="dropdown__panel-header">
              <div className="dropdown__panel-title">Select month</div>
            </div>
            <div className="dropdown__list dropdown__list--month">
              {months.map((mo) => (
                <button
                  key={mo}
                  className={`dropdown__month-item ${mo === value ? 'dropdown__month-item--active' : ''}`}
                  type="button"
                  onClick={() => {
                    onChange(mo);
                    setOpen(false);
                  }}
                >
                  {formatMonth(mo)}
                </button>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

